<template>
  <div>
    <div id="tasklist">
      <div v-for="list in taskLists" :key="list.id" :list="list">
        <!-- router-link :to="'/list/' + list.id">{{ list.title }}</router-link -->
        <router-link :to="{ name: 'tasks', params: { taskListId: list.id } }" tag="span">
          <a :title="list.updated">{{ list.title }}</a>
        </router-link>
      </div>
    </div>
    <div id="ui" style="border: 1px; margin-top: 2em">
      <b-button v-if="!isSignedIn" @click="handleAuthClick">Authorize</b-button>
      <b-button v-if="isSignedIn" @click="handleSignoutClick">Sign Out</b-button>
    </div>
    <div ui="log" style="font-size: 0.15em; white-space: pre-line; color: #bbb;">
      {{ logs.join("\n") }}
    </div>
    <div style="font-size: 0.15em; white-space: pre-line; color: #bbb;">
      Last checked: {{ last_checked }}<br>
      Last updated: {{ last_updated }}
    </div>
  </div>
</template>
<script>
import BButton from 'bootstrap-vue/es/components/button/button'
export default {
  components: {
    BButton
  },
  // id: string
  // etag: string
  // title: string
  // updated: datetime

  // props: [ 'value' ],
  data () {
    return {
      isSignedIn: false,
      logs: [],
      last_checked: "",
      last_updated: "",
      taskLists: [],
    }
  },
  mounted () {
    console.log('JK: TaskList mounted') //, this.initClient)
    let p = this.$gapi.authorize()
    p.then((r) => {
      console.log('then', r)

      // Listen for sign-in state changes.
      this.$gapi.instance().isSignedIn.listen(this.updateSigninStatus)

      // Handle the initial sign-in state.
      this.isSignedIn = this.$gapi.instance().isSignedIn.get()

      this.listTaskLists()
    })
  },
  methods: {
    updateSigninStatus (isSignedIn) {
      this.isSignedIn = isSignedIn
    },
    listTaskLists () {
      this.$gapi.listTaskLists().then(items => {
        this.taskLists = items.sort((a, b) => { if (typeof a === "undefined" || typeof b === "undefined") console.log('Hmm', a, b); return a.title < b.title ? -1 : a.title > b.title ? 1 : 0 })
        console.log('JK: listTaskLists()', this.taskLists, this.value)
        this.$emit('update', this.taskLists)
      })
    },
    handleAuthClick (/* event */) {
      let r = this.$gapi.gapi.auth2.getAuthInstance().signIn()
      console.log('handleAuthClick', r)
      return r
    },
    handleSignoutClick (/* event */) {
      this.$gapi.gapi.auth2.getAuthInstance().signOut()
    },
    date () {
      return (new Date()).toLocaleString("sv-SE", { timeZone: "Asia/Tokyo" }).replace(/\s/, "T").replace(/^20..-/, '').replace(/:..$/, '')
      //return (new Date()).toJSON().replace(/^20..-/, '').replace(/\.\d{3}Z/, '')
    },
    // タスクリスト自体が変わっていないかをチェック
    checkUpdate () {
      const date = this.date() //(new Date()).toJSON().replace(/^20..-/, '').replace(/\.\d{3}Z/, '')
      this.log('TaskList:checkUpdate() ' + date)
      console.log('TaskList:checkUpdate()', date)
      // el.etag がなぜか含まれていない
      let short = el => { return [ el.id, el.title ] }
      let jsonize = list => JSON.stringify(list.map(short))
      this.$gapi.listTaskLists().then(items => {
        let sorted = items.sort((a, b) => { return a.title < b.title ? -1 : a.title > b.title ? 1 : 0 })
        // updated 以外が変わっていないかをチェック
        if (jsonize(sorted) !== jsonize(this.taskLists)) {
          this.taskLists = sorted
          console.log('TaskList#checkUpdate(): shortcut changed')
          return
        }
        let changed = []
        for (let i = 0; i < sorted.length; i++) {
          if (sorted[i].updated !== this.taskLists[i].updated) {
            changed.push([ sorted[i].id, sorted[i].updated, this.taskLists[i].updated ])
          }
        }
        this.last_checked = this.date()
        if (changed.length > 0) {
          this.$emit('timestamp_updated', changed)
          this.log('TaskList: changed')
          this.last_updated = this.date()
          console.log('TaskList: changed')
          this.taskLists = sorted
        } else {
          this.log('TaskList: not changed')
          console.log('TaskList: not changed')
          this.$emit('check_update')
        }
      }).catch(err => {
        location.reload()
      })
    },
    log (text) {
      if (this.logs.length > 20) {
        this.logs.shift()
      }
      this.logs.push(text)
    },
  },
}
</script>
<style scoped>
</style>
